import api from "../../services/api";

const TOKEN_KEY = "access_token";
const REFRESH_KEY = "refresh_token";

export const authService = {

  async login(credentials) {

    const response = await api.post("/authentication/login/", credentials);

    const {access, refresh, user,} = response.data;

    localStorage.setItem(TOKEN_KEY, access);

    localStorage.setItem(REFRESH_KEY, refresh);

    localStorage.setItem("admin_user", JSON.stringify(user));

    return response.data;
  },

  logout() {

    localStorage.removeItem(TOKEN_KEY);

    localStorage.removeItem(REFRESH_KEY);

    localStorage.removeItem("admin_user");
  },

  getAccessToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  getRefreshToken() {
    return localStorage.getItem(REFRESH_KEY);
  },

  getCurrentUser() {

    const user = localStorage.getItem("admin_user");

    return user ? JSON.parse(user) : null;
  },

  isAuthenticated() {
    return !!this.getAccessToken();
  },
};